import React from 'react';
import { Link } from '@tanstack/react-router';
import Heading from '../typography/Heading';
import Paragraph from '../typography/Paragraph';

const PromoBanner: React.FC = () => {
  return (
    <div
      className="relative h-[300px] md:h-[400px] mx-4 mt-8 mb-8 md:mb-16 rounded-3xl overflow-hidden"
      style={{
        background: `linear-gradient(to right, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.5) 50%), url('/assets/images/home/why-choose-overlay-bg.jpg')`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <div className="relative h-full flex items-center px-4 md:px-12 lg:px-16">
        <div>
          <div className="w-full lg:w-[70%] mb-8">
            <Heading className="text-white text-xl md:!text-[32px]">
              Ready to simplify property management?
            </Heading>
            <Paragraph className="text-white">
              Explore our platform today and see how we make ownership and
              community management effortless.
            </Paragraph>
          </div>
          <Link to="/sign-in" className="text-lg text-white font-bold bg-[#5761eb] px-6 py-3 rounded-lg">
            Get started free
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
